/**
 * Preferencias visuales de la UI en `localStorage` (claves con prefijo `middle:`).
 *
 * El almacenamiento puede no estar: modo privado, cookies bloqueadas, cuota
 * llena. Leer devuelve `null` y escribir devuelve `false`, y quien llama sigue
 * con el valor en memoria. Una preferencia visual que no se recuerda es una
 * molestia, no un error que haya que mostrar.
 */

export function readLocalPreference(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    // Almacenamiento bloqueado: se usa el valor por defecto.
    return null;
  }
}

/** Guarda la preferencia. `false` si no se pudo: el valor vive solo en memoria. */
export function writeLocalPreference(key: string, value: string): boolean {
  try {
    window.localStorage.setItem(key, value);
    return true;
  } catch {
    // Almacenamiento bloqueado o lleno: la eleccion dura lo que dure la pestana.
    return false;
  }
}
